const { origin, pathname } = window.location;

export const paperReadingPath = '/reading';
export const isPaperReading = Boolean(pathname.match(new RegExp(`^${paperReadingPath}($|/)`)));
export const appUrl = isPaperReading ? `${origin}${paperReadingPath}` : origin;
export const paperLoginPath = `${origin}/login/student`;
